import React, { useState } from 'react';
import { TextField, Grid, Button, Box } from '@mui/material';
import Header from "../../Layout/Header";

const WinderMachine = () => {
  const [formData, setFormData] = useState({
    machineCode: '',
    machineName: '',
    minWidthDeckle: '',
    maxWidthDeckle: '',
    knives: '',
    minDiameter: '',
    maxDiameter: '',
    minWeightPerCombination: '',
    setWeight: '',
  });

  const [validationErrors, setValidationErrors] = useState({});
  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Validate minWidthDeckle and maxWidthDeckle before submission
    if (parseFloat(formData.minWidthDeckle) > parseFloat(formData.maxWidthDeckle)) {
      setValidationErrors({
        ...validationErrors,
        minWidthDeckle: 'Minimum Deckle should not be greater than Maximum Deckle.',
      });
      return;
    }

    // Handle form submission logic here
    console.log(formData);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newErrors = { ...validationErrors };

    // Validate specific fields
    if (name === 'minWidthDeckle' || name === 'maxWidthDeckle' || name === 'minDiameter' || name === 'maxDiameter' || name ==='minWeightPerCombination' || name === 'setWeight')
     {
        const floatValue = parseFloat(value);
      if (!isNaN(value) && parseFloat(value) >= 0) {
        // newErrors = { ...newErrors, [name]: '' }; // Clear the error message
        // setFormData({ ...formData, [name]: value });
        // Round the value to one decimal place
        const roundedValue = floatValue.toFixed(1);
        newErrors = { ...newErrors, [name]: '' }; // Clear the error message
        setFormData({ ...formData, [name]: roundedValue });
      } else {
        newErrors = { ...newErrors, [name]: 'Enter a valid non-negative number.' };
      }
    } 
    else if (name === 'knives') 
    {
      const intValue = parseInt(value);
      if (!isNaN(intValue) && intValue >= 0 && intValue <= 20) {
        newErrors = { ...newErrors, [name]: '' }; // Clear the error message
        setFormData({ ...formData, [name]: intValue });
      } else {
        newErrors = { ...newErrors, [name]: 'Enter a valid integer between 0 and 20.' };
      }
    } 
    
    else 
    {
      setFormData({ ...formData, [name]: value });
    }

    if (parseFloat(formData.minWidthDeckle) <= parseFloat(formData.maxWidthDeckle)) {
      newErrors = { ...newErrors, minWidthDeckle: '' }; // Clear the error message
    }

    setValidationErrors(newErrors);
  };

  return (
    <Box m="20px">
      <Header title="Winder Machine" subtitle="Add Winder Machine Details" />
      <form onSubmit={handleFormSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <TextField
              fullWidth
              required
              name="machineCode"
              label="Machine Code"
              value={formData.machineCode}
              onChange={handleInputChange}             
            />
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              required
              name="machineName"
              label="Machine Name"
              value={formData.machineName}
              onChange={handleInputChange}           
              
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              name="minWidthDeckle"
              label="Min Width Deckle"
              value={formData.minWidthDeckle}
              onChange={handleInputChange}
              error={Boolean(validationErrors.minWidthDeckle)}
              helperText={validationErrors.minWidthDeckle}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              name="maxWidthDeckle"
              label="Max Width Deckle"
              value={formData.maxWidthDeckle}
              onChange={handleInputChange}
              error={Boolean(validationErrors.maxWidthDeckle)}
              helperText={validationErrors.maxWidthDeckle}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              fullWidth
              name="knives"
              label="Knives"
              value={formData.knives}
              onChange={handleInputChange}
              error={Boolean(validationErrors.knives)}
              helperText={validationErrors.knives}
            />
          </Grid>
          {/* Include the remaining fields here */}
          <Grid item xs={3}>
        <TextField
          fullWidth
          name="minDiameter"
          label="Min Diameter"
          value={formData.minDiameter}
          onChange={handleInputChange}
        />
        </Grid>
          <Grid item xs={3}>
        <TextField
          fullWidth
          name="maxDiameter"
          label="Max Diameter"
          value={formData.maxDiameter}
          onChange={handleInputChange}
        />
        </Grid>
          <Grid item xs={3}>
        <TextField
          fullWidth
          name="minWeightPerCombination"
          label="Min Weight Per Combination"
          value={formData.minWeightPerCombination}
          onChange={handleInputChange}
        />
        </Grid>
          <Grid item xs={3}>
        <TextField
          fullWidth
          name="setWeight"
          label="Set Weight"
          value={formData.setWeight}
          onChange={handleInputChange}
        />
        </Grid>
        </Grid>
        <Box mt={2}>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default WinderMachine;
